import { render } from "./UpdateTaskStatusDialog.vue?vue&type=template&id=18faa41a&scoped=true"
import script from "./UpdateTaskStatusDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTaskStatusDialog.vue?vue&type=script&lang=js"

import "./UpdateTaskStatusDialog.vue?vue&type=style&index=0&id=18faa41a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18faa41a"]])

export default __exports__